<c-container>
  <app-game-settings [activeGame]="activeGame"></app-game-settings>
</c-container>

